<template>
  <div class="login-page">
      <div class="site-wrapper">
          <div class="login-wrapper">
              <div class="login-banner">
                  <div class="banner-hero banner-login">
                      <div class="illustrator-wrap">
                          <div class="illustrator">
                              <div class="bg"></div>
                          </div>
                      </div>
                      <div class="box-text">
                        <img src="@/assets/images/logo.svg" style="padding-bottom: 12px">
                        <p class="lead text-center">Trang dành cho giảng viên của Learnova. </p>
                      </div>
                  </div>
              </div>
              <div class="login-content">
                  <div class="inner">
                      <form v-on:submit.prevent="handleLogin" class="form login-form">
                          <h3 class="text-center" style="padding-bottom: 18px"><strong>Đăng nhập</strong></h3>
                          <div class="login-form">
                            <b-form-group
                              id="email"
                              label="Email"
                              :state="emailState"
                            >
                              <b-form-input
                                ref="email"
                                v-model="form.email"
                                :state="emailState"
                                placeholder="Vui lòng nhập email"
                                trim
                              />
                            </b-form-group>
                            <b-form-group
                              id="password"
                              label="Mật khẩu"
                              :state="passwordState"
                            >
                              <b-form-input
                                ref="password"
                                v-model="form.password"
                                placeholder="Vui lòng nhật mật khẩu"
                                :state="passwordState"
                                trim
                              />
                            </b-form-group>
                          </div>
                          <div class="form-group">
                              <button
                                class="btn btn-danger btn-block btn-h60"
                                @click.prevent="handleLogin"
                              >
                                <strong>Đăng nhập</strong>
                              </button>
                              <div class="mt-3 text-right">
                                  <a href="javascript:;" class="text-secondary">Bạn quên mật khẩu?</a>
                              </div>
                          </div>
                      </form>
                  </div>

              </div>
          </div>
      </div>
  </div>
</template>

<script>
import _ from 'lodash'
import validator from 'validator'

export default {
  computed: {
    emailState() {
      if (!this.form.email) {
        return
      }
      return validator.isEmail(this.form.email)
    },
    passwordState() {
      if (!this.form.password) {
        return
      }
      return this.form.password !== ''
    }
  },
  data() {
    return {
      loading: false,
      form: {
        email: '',
        password: ''
      }
    }
  },
  mounted() {
    if (this.form.email === '') {
      this.$refs.email.focus()
    } else if (this.form.password === '') {
      this.$refs.password.focus()
    }
  },
  methods: {
    handleLogin() {
      this.$store.dispatch('user/login', this.form)
        .then(() => {
          this.$router.push({ path: '/' })
        })
        .catch(error => {
          this.$bvToast.toast(_.get(error, 'response.data.error.message') || error.message, {
            title: 'Thất bại',
            variant: 'danger'
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
/*-- Login Page --*/
.login-wrapper{
width: 100%;
min-height: 100vh;
display: flex;
justify-content: flex-end;
}
.login-wrapper .login-banner{
width: 58%;
height: 100%;
position: fixed;
left: 0;
top: 0;
}
.login-wrapper .login-banner .banner-hero {
width: 100%;
height: 100%;
display: flex;
justify-content: center;
align-items: center;
position: relative;
}

.login-wrapper .login-banner .banner-hero .box-text{
width: 50%;
margin: 0 auto;
position: relative;
z-index: 10;
}
.login-wrapper .login-banner .banner-hero .box-text h3 {
font-size: 90px;
}
/* Banner Register Hero*/
.login-wrapper .login-banner .banner-hero.banner-register {
background-color: #FF795A;
color: #fff;
}
.login-wrapper .login-banner .banner-hero.banner-register .illustrator-wrap{
position: absolute;
width: 120%;
left: -10%;
}
.login-wrapper .login-banner .banner-hero.banner-register .illustrator {
width: 100%;
height: 0;
position: relative;
padding-bottom: 67%;
}
.login-wrapper .login-banner .banner-hero.banner-register .illustrator .bg{
width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    content: '';
    background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-image: url('../assets/images/temp/register-illustratror.png');
}

/* Banner Login*/
.login-wrapper .login-banner .banner-hero.banner-login .box-text {
margin-bottom: 40%;
}
.login-wrapper .login-banner .banner-hero.banner-login .illustrator-wrap{
width: 100%;
order: 10;
position: absolute;
left: 0;
bottom: 0;
}
.login-wrapper .login-banner .banner-hero.banner-login .illustrator {
width: 100%;
height: 0;
position: relative;
padding-bottom: 56.25%;
}
.login-wrapper .login-banner .banner-hero.banner-login .illustrator .bg{
width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    content: '';
    background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-image: url('../assets/images/temp/login-illustrator.jpg');
}
/* Banner Register Complated */
.login-wrapper .login-banner .banner-hero.banner-register-complated .box-text {
margin-bottom: 40%;
}
.login-wrapper .login-banner .banner-hero.banner-register-complated .illustrator-wrap{
width: 100%;
order: 10;
position: absolute;
left: 0;
bottom: 0;
}
.login-wrapper .login-banner .banner-hero.banner-register-complated .illustrator {
width: 100%;
height: 0;
position: relative;
padding-bottom: 56.25%;
}
.login-wrapper .login-banner .banner-hero.banner-register-complated .illustrator .bg{
width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    content: '';
    background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-image: url('../assets/images/temp//register-complated.jpg');
}

.login-wrapper .login-content{
  width: 42%;
display: flex;
justify-content: center;
align-items: center;
}
.login-wrapper .login-content .inner{
max-width: 480px;
}

/* Login Form */
.login-form{
margin-top: 30px;
margin-bottom: 30px;
padding: 30px;
}
.login-form .label {
font-size: 20px;
}
.login-form .form-group {
margin-bottom: 1.5rem;
}
.login-form .form-group .form-control {
border:1px solid rgba(0,0,0,0.05);
height: 50px;
padding-left: 1rem;
padding-right: 1rem;
}
.login-form .form-group .form-control:focus{
border:1px solid rgba(0,0,0,0.2);
}

@media screen and (max-width: 1440px){
.login-wrapper .login-banner {
width: 55%;
}
.login-wrapper .login-content {
width: 45%;
}
.login-wrapper .login-content .inner{
max-width: 420px;
}
.login-wrapper .login-banner .banner-hero .box-text{
width: 60%;
}
.login-wrapper .login-banner .banner-hero .box-text h3{
font-size: 72px;
}
}
@media screen and (max-width: 1199px){
.login-wrapper .login-banner {
width: 50%;
}
.login-wrapper .login-content {
width: 50%;
}
.login-wrapper .login-content .inner{
max-width: 380px;
}
.login-wrapper .login-banner .banner-hero .box-text{
width: 80%;
}
.login-wrapper .login-banner .banner-hero .box-text h3{
font-size: 64px;
}
.lead,
.login-form .label{
font-size: 18px;
}

}
@media screen and (max-width: 991px){
  .login-wrapper .login-banner {
    display: none;
  }
  .login-wrapper .login-content {
    width: 100%;
  }
  .login-wrapper .login-content .inner{
  max-width: 360px;
  }
  .login-wrapper .login-content .inner{
    max-width: 480px;
  }
}
</style>
